/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateWebhookResponse
 */
export interface CreateWebhookResponse {
  /**
   *
   * @type {string}
   * @memberof CreateWebhookResponse
   */
  webhookId: string;
  /**
   *
   * @type {string}
   * @memberof CreateWebhookResponse
   */
  secretKey: string;
}

/**
 * Check if a given object implements the CreateWebhookResponse interface.
 */
export function instanceOfCreateWebhookResponse(
  value: object,
): value is CreateWebhookResponse {
  if (!("webhookId" in value) || value["webhookId"] === undefined) return false;
  if (!("secretKey" in value) || value["secretKey"] === undefined) return false;
  return true;
}

export function CreateWebhookResponseFromJSON(
  json: any,
): CreateWebhookResponse {
  return CreateWebhookResponseFromJSONTyped(json, false);
}

export function CreateWebhookResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateWebhookResponse {
  if (json == null) {
    return json;
  }
  return {
    webhookId: json["webhookId"],
    secretKey: json["secretKey"],
  };
}

export function CreateWebhookResponseToJSON(json: any): CreateWebhookResponse {
  return CreateWebhookResponseToJSONTyped(json, false);
}

export function CreateWebhookResponseToJSONTyped(
  value?: CreateWebhookResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    webhookId: value["webhookId"],
    secretKey: value["secretKey"],
  };
}
